<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading" v-if="!page.isNew">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined :to="page.isNew ? '/agcs' : `/agcs/${$route.params.id}`">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Nome" v-model="dataset.data.name" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense type="datetime-local" label="Data" v-model="dataset.data.date" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                            <!-- <v-menu v-model="menu" :close-on-content-click="false"
                                                transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field dense v-model="computedDateFormatted" label="Data" outlined 
                                                        :rules="[$rules.required]" readonly v-bind="attrs" hide-details="auto"
                                                        v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="dataset.data.date" no-title
                                                    @input="menu = false"></v-date-picker>
                                            </v-menu> -->
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-autocomplete dense id="type" :items="dataset.clients" label="Caso"
                                                v-model="dataset.data.client_id" item-value="id" item-text="name" outlined
                                                hide-details="auto" no-data-text="Nenhum caso encontrado">
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <p class="font-weight-bold">Descrição</p>
                                            <tiptap-vuetify v-model="dataset.data.description" :rules="[$rules.required]"
                                                :extensions="extensions" hide-details="auto" />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>

<script>
import states from "@/common/data/states.data"
import string from "@/common/util/string"

import axios from "axios"

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Link, Paragraph
} from 'tiptap-vuetify'


export default {
    name: "FaqDetails",

    components: { 'tiptap-vuetify': TiptapVuetify },

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        menu: false,
        dataset: {
            breadcrumbItems: [],
            date: null,
            data: {},
            clients: []
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
        },
        extensions: [
            Underline,
            Strike,
            Italic,
            Bold,
            Link,
            Paragraph,
        ],
    }),

    created() {
        this.loadData()
    },

    computed: {
        computedDateFormatted() {
            return this.formatDate(this.dataset.data.date)
        },
    },


    methods: {
        // Depois de salvar: lista (nova) ou detalhe da assembleia (edição)
        goBack() {
            this.$router.replace(this.page.isNew ? "/agcs" : `/agcs/${this.$route.params.id}`);
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.loadClients();
            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Nova assembleia" : "Editar assembleia";
        },

        formatDate(date) {
            if (!date) return null

            return this.$moment(date).format('DD/MM/YYYY')
        },
        parseDate(date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Início",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Assembleias",
                disabled: false,
                to: "/agcs",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? "Nova assembleia" : "Editar assembleia",
                disabled: true,
                exact: true,
            });
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            if(!this.$moment(this.dataset.data.date).isValid()) {
                this.$dialog.notify.error("Data inválida, corrija-a e tente novamente!", {
                    position: 'top-right',
                    timeout: 2000
                })

                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir a Assembleia?',
                title: 'Incluir Assembleia',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/admin/general-meetings', payload);

                this.$dialog.notify.info("Assembleia salva com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;    

            if(!this.$moment(this.dataset.data.date).isValid()) {
                this.$dialog.notify.error("Data inválida, corrija-a e tente novamente!", {
                    position: 'top-right',
                    timeout: 2000
                })

                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar a Assembleia?',
                title: 'Atualizar Assembleia',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/admin/general-meetings/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Assembleia salva com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async load() {


            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/general-meetings/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = data;

                this.dataset.data.date = this.$moment(this.dataset.data.date).format("YYYY-MM-DD HH:mm")

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadClients() {

            try {
                const result = await axios.get(`/api/clients`, { params: { limit: 10000000 } });

                const data = result.data.content.data;

                data.sort((a, b) => a.name.localeCompare(b.name));

                this.dataset.clients = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                date: this.dataset.data.date,
                client_id: this.dataset.data.client_id,
                description: this.dataset.data.description,
            }

            return data;
        },


    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>